/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 01.07.13, 08:40
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */


import Event = createjs.Event;

export class IdleScreenEvent extends Event {
    public static SHOW: string = "showIdleScreen";
    public static HIDE: string = "hideIdleScreen";

    constructor(type: string, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
    }
}

